var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-dropdown',{staticClass:"actions-dropdown",attrs:{"label":_vm.laptop ? _vm.$t('common.labels.options') : '',"items":_vm.actions,"actions-title":_vm.$t('common.labels.options'),"bordered":""},on:{"customize":_vm.openCustomizeTableModal,"export":_vm.openCsvExportModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }